import React, { useState, useContext } from "react";
import { QuizContext } from "../../../assets/context/index";
import "./styled.css";

const questions = [
  {
    option: "a) Foco exclusivo em grandes cargas",
    correct: false,
  },
  {
    option: "b) Adaptação a qualquer porte de empresa",
    correct: true,
  },
  {
    option: "c) Restrição a indústrias específicas",
    correct: false,
  },
  {
    option: "d) Ignorar a variabilidade de carga",
    correct: false,
  },
  {
    option: "e) Ênfase apenas em indústrias de tecnologia",
    correct: false,
  },
];

export default function Question15(props) {
  const { t } = useContext(QuizContext);
  const { setQuestionSelected, checkAnswers } = props;
  const [optionSelected, setOptionSelected] = useState("");

  function selectOption(option) {
    setOptionSelected(option.option);

    setQuestionSelected((state) => {
      return {
        ...state,
        question15: {
          title:
            "Por que a SAI Smart Logistics é relevante para cargas de diferentes tamanhos e tipos de indústrias?",
          option: option.option,
          correct: option.correct,
          order: 15
        },
      };
    });
  }
  return (
    <div style={{ marginTop: 30 }}>
      <h5 style={{ textAlign: "center" }}>
        {t(
          "Por que a SAI Smart Logistics é relevante para cargas de diferentes tamanhos e tipos de indústrias?"
        )}
      </h5>

      <div className="div-options-question-ste">
        {questions.map((e, i) => (
          <a
            key={i}
            className={`option-question-ste ${
              optionSelected === e.option && "selected-option-question-ste"
            } ${checkAnswers && (e.correct ? "check-true" : "check-false")}`}
            onClick={() => {
              if (!checkAnswers) {
                selectOption(e);
              }
            }}
          >
            {t(e.option)}
          </a>
        ))}
      </div>
    </div>
  );
}
